// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Qxyl","title":"InfoRow_title__OA4vF"};